import Vue from 'vue'

import 'vue-date-pick/dist/vueDatePick.css';
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueAnalytics from 'vue-analytics';
import './plugins/element.js'
import './assets/all.scss';
import './assets/header.scss';
import './assets/new_style.scss';
import '@/mock'
import Moment from 'moment'
Vue.prototype.moment = Moment
Vue.config.productionTip = false

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-161408605-1',
  router
});

// 判斷是否支援localStorage
if (!window.localStorage) {
  alert("手機瀏覽器不支援，請聯絡「易立洗」協助回報")
  // if (confirm('您需要更新您的APP')) {
  //   location.href = 'auolohas://auolohas/closeweb'
  // } else {
  //   location.href = 'auolohas://auolohas/closeweb'
  // }
} else {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
